<template>
    <div id="dashboard-page">
        <b-row>
          <b-col md='8'>
            <h3 class="mb-3">{{$route.name}}</h3>
          </b-col>
          <b-col md='4' class="text-right">
              <router-link to="/dashboard"><b-button variant="outline-primary" class="btn btn-sm mr-1 active">ERP</b-button></router-link>
              <router-link to="/vehicle-dashboard"><b-button variant="outline-primary" class="btn btn-sm">Vehicle</b-button></router-link>
          </b-col>
          <b-col md="7 mb-3">
              <b-row>
                  <b-col md="6">
                      <a href="#/overtime?limit=25&order=createdAt&page=1&status=Requested">
                          <b-card class="p-3 custom-card border-radius">
                              <b-row>
                                  <b-col md="4">
                                      <font-awesome-icon icon="scroll" class="text-primary fa-4x" ></font-awesome-icon>
                                  </b-col>
                                  <b-col md="8 text-right">
                                      <p class="text-primary m-0"><strong>Overtime Request</strong></p>
                                      <h3 class="text-secondary p-0 m-0"><strong>
                                          <a href="#/overtime?limit=25&order=createdAt&page=1&status=Requested">
                                              Total 200
                                          </a>
                                      </strong></h3>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </a>
                  </b-col>
                  <b-col md="6">
                      <a href="#/leave?limit=25&order=createdAt&page=1&status=Requested">
                          <b-card class="p-3 custom-card border-radius">
                              <b-row>
                                  <b-col md="4">
                                      <font-awesome-icon icon="calendar" class="text-success fa-4x" ></font-awesome-icon>
                                  </b-col>
                                  <b-col md="8 text-right">
                                      <p class="text-success m-0"><strong>Leave Request</strong></p>
                                      <h3 class="text-secondary p-0 m-0"><strong>
                                          <a href="#/leave?limit=25&order=createdAt&page=1&status=Requested">
                                              Total 200
                                          </a>
                                      </strong></h3>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </a>
                  </b-col>
                  <b-col md="6 mt-3">
                      <a href="#/reimbursement?limit=25&order=createdAt&page=1&status=Requested">
                          <b-card class="p-3 custom-card border-radius">
                              <b-row>
                                  <b-col md="4">
                                      <font-awesome-icon icon="comments-dollar" class="text-warning fa-4x" ></font-awesome-icon>
                                  </b-col>
                                  <b-col md="8 text-right p-0">
                                      <p class="text-warning m-0"><strong>Reimbursement Request</strong></p>
                                      <h3 class="text-secondary p-0 m-0"><strong>Total 200</strong></h3>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </a>
                  </b-col>
                  <b-col md="6 mt-3">
                      <a href="#/report">
                          <b-card class="p-3 custom-card border-radius">
                              <b-row>
                                  <b-col md="4">
                                      <font-awesome-icon icon="clipboard-list" class="text-info fa-4x" ></font-awesome-icon>
                                  </b-col>
                                  <b-col md="8 text-right">
                                      <p class="text-info m-0"><strong>Vehicle Report</strong></p>
                                      <h3 class="text-secondary p-0 m-0"><strong>Total 200</strong></h3>
                                  </b-col>
                              </b-row>
                          </b-card>
                      </a>
                  </b-col>
              </b-row>
          </b-col>
          <b-col md="5 mb-3">
              <b-card class="text-center border-radius">
                  <apexchart type="pie" width="380" height="400" :options="chartOptionsChart" :series="seriesChart"></apexchart>
              </b-card>
          </b-col>

          <b-col md="4">
              <b-card class="border-radius">
                  <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
              </b-card>
          </b-col>

          <b-col md="4">
              <b-card class="border-radius">
                  <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
              </b-card>
          </b-col>

          <b-col md="4">
              <b-card class="border-radius">
                  <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
              </b-card>
          </b-col>
        </b-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import VueApexCharts from 'vue-apexcharts'
    Vue.use(VueApexCharts)
    
    Vue.component('apexchart', VueApexCharts)
    
    export default {
        name: 'NavigationBar',
        components: {
        },
        data () {
            return {
                seriesChart: [44, 55, 13, 43, 22],
                chartOptionsChart: {
                    chart: {
                    width: 380,
                    type: 'pie'
                    },
                    labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                    responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                        width: 200
                        },
                        legend: {
                        position: 'bottom'
                        }
                    }
                    }]
                },
                series: [
                    {
                        name: 'Overtime',
                        data: [30, 35, 41, 36, 26, 45, 48, 52, 53, 41, 50, 60]
                    }
                ],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Des'],
                    },
                    yaxis: {
                        title: {
                            text: 'Overtime'
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                            return "Total " + val
                            }
                        }
                    }
                },
                seriesDonat: [44, 55, 41, 17, 15],
                chartOptionsDonat: {
                    chart: {
                        type: 'donut',
                    },
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                chart: {
                                width: 200
                                },
                                legend: {
                                position: 'bottom'
                                }
                            }
                        }
                    ]
                }
            }
        },
    }
    
</script>